module.exports = __webpack_public_path__ + "f6ea751e936ade6edcd03a26b8153b4a.ttf";